
let Config={
  //UAT
  // WSS:"wss://mw.mjhero.cn:/web_test",
  // HTTP:"http://mw.mjhero.cn:9588/",


  //local
  // WSS:"ws://127.0.0.1:9566/web",
  // HTTP:"http://127.0.0.1:9566/",
  //RELEASE
  WSS:"wss://mw.mjhero.cn:/web",
  HTTP:"https://mw.mjhero.cn/",
};

export default Config



// WEBPACK FOOTER //
// ./src/view/config.js